import React, { useEffect, useState } from 'react';
import { PaperPlaneTilt } from '@phosphor-icons/react';
import AdventureCard from '@/components/home/AdventureCard';
import DestinationPicker from '@/components/home/DestinationPicker';

const fmt = (ms) => {
  const s = Math.max(0, Math.ceil(ms / 1000));
  return `${Math.floor(s / 60)}:${String(s % 60).padStart(2, '0')}`;
};

export const WanderPanel = ({ bubble, wander, minutes, first, places, onSend, onDue, busy, cardActions }) => {
  const [now, setNow] = useState(Date.now());
  const [dest, setDest] = useState(null);
  useEffect(() => {
    const t = setInterval(() => setNow(Date.now()), 1000);
    return () => clearInterval(t);
  }, []);

  const left = wander?.status === 'away' ? new Date(wander.returns_at).getTime() - now : 0;
  useEffect(() => { if (wander?.status === 'away' && left <= 0) onDue(); }, [wander, left <= 0]); // eslint-disable-line

  if (wander?.status === 'returned') return <AdventureCard bubble={bubble} card={wander} busy={busy} {...cardActions} />;

  if (wander?.status === 'away' || wander?.status === 'resolving') {
    return (
      <div className="home-card" data-testid="wander-away">
        <p className="text-xs uppercase tracking-[0.25em] text-bx-cyan font-bold">exploring {wander.place}</p>
        <p className="mt-3 text-lg text-white/90">{bubble.name} is out there on its own. Who knows who it'll meet.</p>
        <p className="mt-2 font-mono text-3xl text-white" data-testid="wander-countdown">{left > 0 ? fmt(left) : 'arriving…'}</p>
        <p className="mt-1 text-sm text-white/65">You can close the app — it will wait for you with a story.</p>
      </div>
    );
  }

  return (
    <div className="home-card" data-testid="wander-idle">
      <p className="text-lg text-white/90">{first ? `${bubble.name} wants to see the world. Where should it go first?` : `Where should ${bubble.name} explore next?`}</p>
      <p className="mt-1 text-sm text-white/65">It goes on its own for {first ? 'about a minute and a half' : `${minutes} minutes`} and comes back with whatever it finds.</p>
      <div className="mt-4"><DestinationPicker places={places} value={dest} onChange={setDest} /></div>
      <button onClick={() => onSend(dest)} disabled={busy} data-testid="wander-send-btn" className="mt-5 btn-volt px-6 py-3 rounded-full inline-flex items-center gap-2">
        <PaperPlaneTilt size={18} weight="bold" /> {dest ? `Let ${bubble.name} go` : `Let ${bubble.name} choose`}
      </button>
    </div>
  );
};

export default WanderPanel;
